import PatientAPI from "../../api/patient.js";
import router from "../../router";

export const patient = {
    namespaced: true,
    state: {
        patients: {},
        lastUpdate: null,
        patient: {
            examinations: []
        },
        patientLoadStatus: 0
    },
    actions: {
        PATIENTS: ({ state, commit }) =>
            PatientAPI.PATIENTS(state.lastUpdate)
                .then(
                    ({ data: { data: patients, lastUpdate: lastUpdate } }) => {
                        commit("PATIENTS", patients);
                        commit("LAST_UPDATE", lastUpdate);
                    }
                )
                .catch(() => {
                    commit("PATIENTS", {});
                    commit("LAST_UPDATE", null);
                }),

        PATIENT: ({ commit }, data) =>
            PatientAPI.PATIENT(data.id)
                .then(({ data: patient }) => commit("PATIENT", patient))
                .catch(() => commit("PATIENT", {})),
        RESET: ({ commit }) =>
            commit("PATIENT", {
                examinations: [],
                cf: "",
                province: "",
                zip: "",
                birthplace_province: ""
            }),

        SAVE: ({ }, patient) => PatientAPI.SAVE(patient).then(({ data: p }) => patient.id ? null : router.push('/patients/' + p.id)),

        DELETE: ({ commit, state }) =>
            PatientAPI.DELETE_PATIENT(state.patient.id).then(() =>
                commit("DELETE_PATIENT", state.patient.id)
            )
    },

    mutations: {
        PATIENTS: (state, patients) =>
            (state.patients = Object.assign(state.patients, patients)),

        LAST_UPDATE: (state, lastUpdate) => (state.lastUpdate = lastUpdate),

        PATIENT: (state, patient) => {
            state.patient = patient
            if (patient.id) {
                state.patients[patient.id] = patient
            }
        },

        DELETE_PATIENT: (state, id) => delete state.patients[id]
    }
};
